import React, { Component } from 'react';
import './App.css';

const clockWidth = 200;

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      date: new Date()
    }
  }

  componentDidMount() {
    window.setInterval((e) => {
      this.setState({date: new Date()});
    }, 30);
  }
  render() {

    const secondsPosition = (this.state.date.getSeconds() + this.state.date.getMilliseconds() / 1000) / 60;
    const minutesPosition = (this.state.date.getMinutes() + secondsPosition) / 60;
    const hoursPosition = (this.state.date.getHours() + minutesPosition) / 24;

    const decHoursPosition = hoursPosition;
    const decMinutesPosition = decHoursPosition * 10;
    const decSecondsPositionRaw = decMinutesPosition * 100;
    const decSecondsPosition = decSecondsPositionRaw - Math.sin(2 * Math.PI * decSecondsPositionRaw * 100) / (100 * 2 * Math.PI);
    
    return (
      <div>
        <div className="clock-digital">
          {Math.floor(decHoursPosition * 10)}h {Math.floor(decMinutesPosition * 100) % 100}m {Math.floor(decSecondsPositionRaw * 100) % 100}s
          </div>
        <div className="clock-analog">
          <svg viewBox={`0 0 ${clockWidth} ${clockWidth}`} width={clockWidth} height={clockWidth} xmlns="http://www.w3.org/2000/svg">
            <g transform={"translate(100, 100)"}>
              {Array.from(new Array(10), (v, index) =>
                <text
                    key={index}
                    x={80 * Math.sin(index * 2 * Math.PI / 10)}
                    y={-80 * Math.cos(index * 2 * Math.PI / 10)}
                    fontSize={20}
                    textAnchor="middle"
                    alignmentBaseline="central">
                  {index}
                </text>
              )}
              {Array.from(new Array(100), (v, index) =>
                <g key={index} transform={`rotate(${3.6 * index})`}>
                  {
                    (index % 10 === 0) ?
                      <line x1="0" y1="-95" x2="0" y2="-100" stroke="black" strokeWidth="3" />
                    : (index % 5 === 0) ?
                      <line x1="0" y1="-90" x2="0" y2="-100" stroke="black" strokeWidth="1" />
                    :
                      <line x1="0" y1="-95" x2="0" y2="-100" stroke="black" strokeWidth="1" />
                  }
                </g>
              )}

              <circle
                  cx="0"
                  cy="0"
                  r={clockWidth * 0.0125} />

              <g transform={`rotate(${decHoursPosition * 360})`}>
                <line
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="-10"
                    stroke="black"
                    strokeLinecap="round"
                    strokeWidth="2" />
                <line
                    x1="0"
                    y1="-10"
                    x2="0"
                    y2="-50"
                    stroke="black"
                    strokeLinecap="round"
                    strokeWidth="5" />
              </g>
              <g transform={`rotate(${decMinutesPosition * 360})`}>
                <line
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="-10"
                    stroke="black"
                    strokeLinecap="round"
                    strokeWidth="2" />
                <line
                    x1="0"
                    y1="-10"
                    x2="0"
                    y2="-90"
                    stroke="black"
                    strokeLinecap="round"
                    strokeWidth="5" />
              </g>
              <g transform={`rotate(${decSecondsPosition * 360})`}>
                <circle
                    cx="0"
                    cy="0"
                    r="1.5"
                    fill="red" />
                <line
                    x1="0"
                    y1="20"
                    x2="0"
                    y2="-100"
                    stroke="red"
                    strokeLinecap="round"
                    strokeWidth="1" />
              </g>
            </g>
          </svg>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js